// NPM Imports
import uuid from "react-native-uuid";

// Internals Imports
import { TEMPLATE, WORKFLOW } from "../../constants";

// Destructuring
const { APPROVAL_TYPE, APPROVAL_TYPE_MAP } = TEMPLATE;
const { FORM_FIELD_DATA } = WORKFLOW;

export const formatWorkFlowConditions = response => {
  const data = [];
  (function objToArrayOfObj(item) {
    const obj = {
      id: item.id,
      isDirty: false,
      isNew: false,
      logicalOperator: item.logical_op,
      param: item.param,
      relationalOperator: item.rel_op,
      value: item.value,
    };
    data.push(obj);
    if (item.related_condition) objToArrayOfObj(item.related_condition);
  })(response.rule.conditions);

  // Override existing condition JSON format
  response.rule.conditions = data;
  return response;
};

// eslint-disable-next-line no-unused-vars
export const parsePricelistData = pricelists => {
  const allPricebook = { id: 0, name: "All Price Books" };
  pricelists.unshift(allPricebook);
  return pricelists;
};

export const parseWrkFlowAttributes = response =>
  response.map(item => {
    const obj = {
      name: item.label,
      type: item.field.type,
      attributeId: item.attribute_id,
      props: item.field.props.values,
    };
    return obj;
  });

export const parseWrkFlowData = (response, metaData) => {
  const rules = response.rules || [response].flat();

  rules.forEach(data => {
    if (data && data.conditions) {
      // Replace the param value inside the conditions
      data.conditions.forEach(item => {
        item.param = metaData.attributesHashMap[item.param];
        delete item.sub_param;
      });

      // Replace the mail id's to name
      const actions = data.action.data;

      // Approvers reverse map
      actions.levels.forEach(level => {
        if (level.approvers) {
          level.approvers.forEach(item => {
            item.name = metaData.usersHasMap[item.user_email];
          });
        }
      });

      //* *** Need this for later itrations ****/
      // Followers reverse map
      // actions.followers.forEach(item => {
      //   item.name = metaData.usersHasMap[item.user_email];
      // });
    }
  });

  return response;
};

export const generateFormFiled = (response, pricelist, products, metaData) => {
  const payload = [];
  const rules = (response && response.rules) || [response].flat();

  rules.forEach(data => {
    // get "action" and "condition" form "workflow.js" constant file
    let action = { ...FORM_FIELD_DATA.action, approvers: [{}] };
    let condition = { ...FORM_FIELD_DATA.condition, conditions: [] };

    let id = uuid.v4();

    if (data && data.conditions) {
      // Added custom data need for the workFlow condition component
      const { rule_scopes: ruleScopes } = data;
      const ruleScopesList = ruleScopes.map(item => item.object_type);
      const priceBook = ruleScopes[ruleScopesList.indexOf("DEAL_PRICEBOOK")];
      const product = ruleScopes[ruleScopesList.indexOf("DEAL_SKU")];
      let priceBookData = {};
      let productData = {};
      let type = "DEAL_PRICEBOOK";
      const { usersHasMap, userGroupHasMap } = metaData;

      // set the rule id
      id = data && data.id;

      if (priceBook) {
        priceBookData = pricelist.find(item => item.id === priceBook.object_id);
      } else {
        priceBookData = { id: 0, name: "All Price Books" };
      }

      if (product) {
        productData = products.find(item => item.id === product.object_id);
        type = "DEAL_SKU";
      }

      // Code to update condition JSON
      const conditionPayload = Object.assign(condition, {
        conditions: data.conditions,
        logicalOperator: data.logical_op,
        priceBook: priceBookData,
        product: productData,
        type,
      });
      condition = conditionPayload;

      // Code to update action JSON
      const actions = data.action.data;
      const approvalType = actions.type || APPROVAL_TYPE.Parallel;

      const approversList = [];
      actions.levels.forEach(item => {
        const users =
          (item.approvers &&
            item.approvers.map(approver => {
              approver.value = usersHasMap[approver.id];
              approver.label = usersHasMap[approver.id];
              approver.type = "user";
              delete approver.name; // Added to handle add approver validation
              delete approver.user_email; // Added to handle add approver validation
              return approver;
            })) ||
          [];
        const userGroup =
          (item.group_approvers &&
            item.group_approvers.map(approver => {
              approver.value = userGroupHasMap[approver.group_id];
              approver.label = userGroupHasMap[approver.group_id];
              approver.type = "group";
              delete approver.group_name; // Added to handle add approver validation
              delete approver.user_email; // Added to handle add approver validation
              return approver;
            })) ||
          [];
        const combinedData = [...users, ...userGroup];
        approversList.push(combinedData);
      });

      const actionPayload = Object.assign(action, {
        id: data.action.id,
        approvalType: APPROVAL_TYPE_MAP[approvalType],
        approvers: approversList.flat(),
        emailSub: actions.request_subject,
        emailMsg: actions.request_email,
        replySub: actions.reply_subject,
        replyMsg: actions.reply_email,
        triggerMessage: data.action.trigger_message,
        // followers: actions.followers,
        // followersMsg: actions.follow_email,
        // quorum: actions.levels[0].quorum,
      });
      action = actionPayload;
    }
    payload.push({ id, action, condition });
  });

  return payload;
};

export const generateWrkFlowMetaData = response => {
  const props = {};
  const attributesReverseHashMap = {};
  const attributesHashMap = {};
  const usersReverseHashMap = {};
  const usersHasMap = {};
  const userGroupReverseHashMap = {};
  const userGroupHasMap = {};

  // Generate Reverse Hash Map for Attributes
  response[1].forEach(item => {
    attributesReverseHashMap[item.label] = item.attribute_id;
  });

  // Generate Forward Hash Map for Attributes
  response[1].forEach(item => {
    attributesHashMap[item.attribute_id] = item.label;
  });

  // Generate Reverse Hash Map for Users
  response[3].users.forEach(item => {
    usersReverseHashMap[item.name] = item.id;
  });

  // Generate Forward Hash Map for Users
  response[3].users.forEach(item => {
    usersHasMap[item.id] = item.name;
  });

  // Generate Reverse Hash Map for Users
  response[5].Usergroups.forEach(item => {
    userGroupReverseHashMap[item.name] = item.id;
  });

  // Generate Forward Hash Map for Users
  response[5].Usergroups.forEach(item => {
    userGroupHasMap[item.id] = item.name;
  });

  // Append mutations to props
  props.attributesHashMap = attributesHashMap;
  props.attributesReverseHashMap = attributesReverseHashMap;
  props.usersHasMap = usersHasMap;
  props.usersReverseHashMap = usersReverseHashMap;
  props.userGroupHasMap = userGroupHasMap;
  props.userGroupReverseHashMap = userGroupReverseHashMap;
  return props;
};



// WEBPACK FOOTER //
// ./src/actions/WorkFlowActions/workFlowMethods.js